import styled from "styled-components";
import { ptToVwConverter, mobileVwConverter } from "../../utils";

export const GridContainer = styled.div`
  display: flex;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(10)}vw;
  }
`;

export const FirstContainer = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  padding: ${ptToVwConverter(8)}vw ${ptToVwConverter(8)}vw
    ${ptToVwConverter(8)}vw 0;
  @media (max-width: 1024px) {
    padding: ${mobileVwConverter(0)}vw ${mobileVwConverter(5)}vw
      ${mobileVwConverter(0)}vw 0;
  }
`;

export const SecondContainer = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  padding: ${ptToVwConverter(8)}vw 0 ${ptToVwConverter(8)}vw
    ${ptToVwConverter(8)}vw;
  @media (max-width: 1024px) {
    padding: ${mobileVwConverter(0)}vw 0 ${mobileVwConverter(0)}vw
      ${mobileVwConverter(5)}vw;
  }
`;
